import React from 'react';

import { ReactComponent as Orange } from './orange.svg';
import { ReactComponent as Pink } from './pink.svg';
import { ReactComponent as Violet } from './violet.svg';
import { ReactComponent as Spiral } from './spiral.svg';

import './AnimatedStroke.less';
import { Stroke } from '../Persona';

const strokeComponentMap = {
    pink: <Pink />,
    orange: <Orange />,
    violet: <Violet />,
    spiral: <Spiral />,
} as Record<Stroke, JSX.Element>;

export const AnimatedStroke = ({ stroke }: { stroke?: Stroke }) => {
    if (!stroke) return null;
    return strokeComponentMap[stroke];
};
